import PropTypes from "prop-types";
import React from "react";
import { Controller } from "react-hook-form";
import validator from "validator";
import { getCountryList } from "../../api";
import { FORM_FIELDS, FORM_VALIDATION } from "../../constants";
import { FormDropDown, FormTextInput } from "../core";

export const VendorDetails = ({ control, register, errors }) => {
  return (
    <>
      <FormTextInput
        labelName={FORM_FIELDS.SERVICE_PROVIDER_NAME}
        id="serviceProviderName"
        required={true}
        {...register("serviceProviderName", {
          required: FORM_VALIDATION.SERVICE_PROVIDER_NAME,
        })}
        error={errors.serviceProviderName}
      />
      <FormTextInput
        labelName={FORM_FIELDS.SERVICE_PROVIDER_URL}
        id="serviceProviderUrl"
        required={true}
        {...register("serviceProviderUrl", {
          required: FORM_VALIDATION.SERVICE_PROVIDER_URL,
          validate: {
            isValidUrl: (value) => {
              if (!validator.isURL(value)) {
                return FORM_VALIDATION.INVALID_SERVICE_PROVIDER_URL;
              }
              return true;
            },
            noWhitespace: (value) => {
              if (/\s/.test(value)) {
                return FORM_VALIDATION.INVALID_SERVICE_PROVIDER_URL;
              }
              return true;
            },
          },
        })}
        error={errors.serviceProviderUrl}
      />
      <FormTextInput
        labelName={FORM_FIELDS.ADDRESS}
        id="address"
        {...register("address")}
      />
      <Controller
        control={control}
        name="country"
        render={({ field }) => (
          <FormDropDown
            {...field}
            labelName={FORM_FIELDS.COUNTRY}
            options={getCountryList()}
            onChange={(selectedOption) => field.onChange(selectedOption)}
          />
        )}
      />
    </>
  );
};

VendorDetails.propTypes = {
  control: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
};
